module.exports = require('./helpers/bundle-url').getBundleURL('2hqst') + "logo.c51670a8.svg";